var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(! _vm.id)?_c('span',[_vm._v(_vm._s(_vm.$t('no_image')))]):(! _vm.src)?_c('i',{staticClass:"icon icon-4x icon-circle-third icon-spin"}):_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }